import React from 'react';
import { Link } from 'react-router-dom';
import { PiStudent } from 'react-icons/pi';
import { 
  BsCalendarCheck, 
  BsGraphUp, 
  BsTable, 
  BsMap, 
  BsSignpost2, 
  BsMortarboard 
} from 'react-icons/bs';
import { MdOutlineDashboardCustomize } from 'react-icons/md';
import { FaUsers, FaChartPie } from 'react-icons/fa';
import DashboardCard from './DashboardCard';

const QuickActionsCard = ({ onHide }) => {
  return (
    <DashboardCard 
      title={<span className="font-medium">Quick Actions</span>} 
      onHide={onHide} 
      isLoading={false}
    >
      <div className="flex">
        {/* Left Column */}
        <ul className="w-1/2 space-y-1">
          <li className="flex items-center">
            <PiStudent className="w-5 h-5 text-gray-500 mr-2" />
            <Link to="/students" className="text-blue-600 hover:underline">
              Manage Students
            </Link>
          </li>
          <li className="flex items-center">
            <BsCalendarCheck className="w-5 h-5 text-gray-500 mr-2" />
            <Link to="/meetings" className="text-blue-600 hover:underline">
              Schedule a Meeting
            </Link>
          </li>
          <li className="flex items-center">
            <BsGraphUp className="w-5 h-5 text-gray-500 mr-2" />
            <Link to="/scheduling-analytics" className="text-blue-600 hover:underline">
              View Scheduling Analytics
            </Link>
          </li>
          <li className="flex items-center">
            <BsTable className="w-5 h-5 text-gray-500 mr-2" />
            <Link to="/reports" className="text-blue-600 hover:underline">
              Generate a Report
            </Link>
          </li>
        </ul>
        {/* Right Column */}
        <ul className="w-1/2 space-y-1">
          <li className="flex items-center">
            <BsMap className="w-5 h-5 text-gray-500 mr-2" />
            <Link to="/curriculum-analytics" className="text-blue-600 hover:underline">
              View Curriculum Analytics
            </Link>
          </li>
          <li className="flex items-center">
            <BsSignpost2 className="w-5 h-5 text-gray-500 mr-2" />
            <Link to="/resources" className="text-blue-600 hover:underline">
              Access Resources
            </Link>
          </li>
          <li className="flex items-center">
            <FaUsers className="w-5 h-5 text-gray-500 mr-2" />
            <Link to="/staff" className="text-blue-600 hover:underline">
              Manage Staff Members
            </Link>
          </li>
          <li className="flex items-center">
            <BsMortarboard className="w-5 h-5 text-gray-500 mr-2" />
            <Link to="/StudentPersistence" className="text-blue-600 hover:underline">
              View Student Persistence
            </Link>
          </li>
        </ul>
      </div>
    </DashboardCard>
  );
};

export default QuickActionsCard;
